export const OBJECT_EDIT_FIELD_GROUP_TWO_COLUMN_MIN_WIDTH_PX = 656;

export const OBJECT_EDIT_REVIEW_SCROLL_BOTTOM_CLEARANCE_PX = 112;

export const OBJECT_EDIT_TITLE_LINE_CLAMP = 3;

export const OBJECT_EDIT_TITLE_ICON_SLOT_HEIGHT = {
  base: '1.75rem',
  _torch: '1.5rem',
} as const;

export const OWASP_FACTOR_BUTTON_ROW_MIN_WIDTH_PX = 320;

export const OWASP_CALCULATOR_TWO_COLUMN_MIN_WIDTH_PX =
  OWASP_FACTOR_BUTTON_ROW_MIN_WIDTH_PX * 2 + 24;

export const CVSS_METRIC_COLUMN_GAP_PX = 24;

export const CVSS_METRIC_COLUMN_MIN_WIDTH_PX = 300;
